import { render, staticRenderFns } from "./StepAddOnes.vue?vue&type=template&id=2d23f5db&scoped=true"
import script from "./StepAddOnes.vue?vue&type=script&lang=js"
export * from "./StepAddOnes.vue?vue&type=script&lang=js"
import style0 from "./StepAddOnes.vue?vue&type=style&index=0&id=2d23f5db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23f5db",
  null
  
)

export default component.exports